var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_2456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 14C10.0906 14 13 11.5375 13 8.5C13 5.4625 10.0906 3 6.50001 3C2.90938 3 6.32051e-06 5.4625 6.32051e-06 8.5C6.32051e-06 9.70625 0.459381 10.8219 1.23751 11.7312C1.12813 12.025 0.965631 12.2844 0.793756 12.5031C0.643756 12.6969 0.490631 12.8469 0.378131 12.95C0.321881 13 0.275006 13.0406 0.243756 13.0656C0.228131 13.0781 0.215631 13.0875 0.209381 13.0906L0.203131 13.0969C0.0312563 13.225 -0.0437437 13.45 0.0250063 13.6531C0.0937563 13.8562 0.284381 14 0.500006 14C1.18126 14 1.86876 13.825 2.44063 13.6094C2.72813 13.5 2.99688 13.3781 3.23126 13.2531C4.19063 13.7281 5.30626 14 6.50001 14ZM14 8.5C14 12.0094 10.9031 14.6531 7.23438 14.9688C7.99376 17.2937 10.5125 19 13.5 19C14.6938 19 15.8094 18.7281 16.7719 18.2531C17.0063 18.3781 17.2719 18.5 17.5594 18.6094C18.1313 18.825 18.8188 19 19.5 19C19.7156 19 19.9094 18.8594 19.975 18.6531C20.0406 18.4469 19.9688 18.2219 19.7938 18.0938L19.7875 18.0875C19.7813 18.0812 19.7688 18.075 19.7531 18.0625C19.7219 18.0375 19.675 18 19.6188 17.9469C19.5063 17.8438 19.3531 17.6938 19.2031 17.5C19.0313 17.2812 18.8688 17.0187 18.7594 16.7281C19.5375 15.8219 19.9969 14.7063 19.9969 13.4969C19.9969 10.5969 17.3438 8.21875 13.9781 8.0125C13.9906 8.17188 13.9969 8.33437 13.9969 8.49687L14 8.5Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_2456"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3H20V19H0V3Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.7ca66710c187ec9a627ce3f6f325e7bc.svg";
export { ForwardRef as ReactComponent };